import { CoralogixDomain } from "@coralogix/browser";

export type ConfigJson = {
  ENVIRONMENT_NAME: "dev" | "int" | "pro";
  ACCERTIFY_ENDPOINT: string;
  CWR_ENDPOINT?: string;
  CWR_APPLICATION_ID?: string;
  CWR_APPLICATION_REGION?: string;
  CWR_IDENTITY_POOL_ID?: string;
  BASE_URL_API_GATEWAY?: string;
  GTM_ID?: string;
  API_ENDPOINT_WS: string;
  HOTJAR_ID?: string;
  CORALOGIX_API_KEY?: string;
  CORALOGIX_APPLICATION_ID?: string;
  CORALOGIX_DOMAIN?: CoralogixDomain;
  CORALOGIX_SESSION_SAMPLING_RATE?: number;
  CORALOGIX_MASK_INPUT?: boolean;
};

export default async function fetchConfig(): Promise<ConfigJson> {
  const response = await fetch("/conf.json");

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
}
